import { I18n } from '@calendly/i18n';
import { FilterMenuButton } from '@calendly/ui/components/filter-menu';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FilterMenuCountBadge, FilterMenuTriggerIcon } from 'components/cui_filter_menu';
const filterIconContainerCss = "fd2zzba";
const FilterIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(filterIconContainerCss, props.className)} />;
});
const triggerLabelGapCss = "te4apkm";
const TriggerLabel = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(triggerLabelGapCss, props.className)} />);
const IconContainer = ({
  filterCount,
  isModalOpen
}) => {
  if (filterCount > 0) return null;
  if (isModalOpen) return <ArrowChevronUpMiniIcon />;
  return <ArrowChevronDownMiniIcon />;
};
const triggerHiddenWhenOpenCss = "teg2o49";
export const FilterButton = forwardRef(({
  isModalOpen,
  filterCount,
  hideWhenOpen = false
}, ref) => {
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <FilterMenuButton ref={ref} hasSelection={filterCount > 0} aria-label={I18n.t('publisher.event_types.filter')} data-testid="meetings-filter-button" disableArrow className={hideWhenOpen ? triggerHiddenWhenOpenCss : undefined}>
      <TriggerLabel>
        <FilterIconContainer>
          <FilterMenuTriggerIcon selected={filterCount > 0} />
        </FilterIconContainer>
        {isDesktopUp && <>
            {I18n.t('publisher.event_types.filter')}
            <IconContainer filterCount={filterCount} isModalOpen={isModalOpen} />
          </>}
        <FilterMenuCountBadge count={filterCount} />
      </TriggerLabel>
    </FilterMenuButton>;
});

// Preserve legacy export name used by tests
FilterButton.displayName = 'FilterButton';

require("./filter_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_button.js");